/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'two-kinds': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M720.5 63.5H431.1s100.2 3.4 100.2 95.6v705.2s6.5 87.2-100.2 95.6H717s-99.3-2.9-99.7-95.6V156.6S611 71 720.5 63.5z"/><path pid="1" d="M596.5 63.5H307.1s100.2 3.4 100.2 95.6v705.2s6.5 87.2-100.2 95.6H593s-99.3-2.9-99.7-95.6V156.6S487 71 596.5 63.5z"/>'
  }
})
